import { createContext } from 'react';
import { PageType } from './configs/pageType';
import { getConfig } from './configs/index';

//will make context default to main
export const PageContext = createContext(getConfig(""));
